import en from './resources/en.json';
import vi from './resources/vi-VN.json';
import es from './resources/es.json';
import ja from './resources/ja_JP.json';
import pt from './resources/pt.json';
import zh from './resources/zh-HK.json';
import ar from './resources/ar.json';
import { TranslationKey, Locale } from './types';

export const defaultLocale = 'en';

const createPlaceholderLocales = (baseLocale: Locale): Locale => {
  return Object.keys(baseLocale).reduce((acc, key: string) => {
    return {
      ...acc,
      [key]: `t: ${baseLocale[key as TranslationKey]}`,
    };
  }, {} as Locale);
};

export const locales = {
  en,
  vi,
  es,
  ja,
  pt,
  zh,
  ar,
  placeholder: createPlaceholderLocales(en),
};

const localesList = Object.keys(locales);

export const extractValidLocale = (locales: readonly string[]): string => {
  return (
    locales
      .filter(locale => typeof locale === 'string')
      .reduce((acc, locale) => [...acc, locale, locale.split('-')[0]], [] as string[])
      .find(locale => localesList.includes(locale)) || defaultLocale
  );
};
